import * as React from "react";
import { useNavigate } from "react-router-dom";

import { Goto } from "@/shared/navigation";

import { NavigationContext } from "./NavigationContext";

interface NavigationProviderProps {
  children: React.ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({
  children,
}) => {
  const navigate = useNavigate();

  const navigationContext = React.useMemo(() => {
    return {
      goto: new Goto(navigate),
    };
  }, [navigate]);

  return (
    <NavigationContext.Provider value={navigationContext}>
      {children}
    </NavigationContext.Provider>
  );
};
